export const PREVENT_FOCUS_CLASS = 'disable-focus-styles';
